import { ReactNode } from 'react'

export function CaseWorkerMessage({ children }: { children: ReactNode }) {
  return (
    <div className="flex w-full justify-end">
      <div className="bg-primary-50/75 border-primary-100 text-primary  border max-w-3/4 flex h-fit w-fit items-start gap-2 whitespace-pre-wrap rounded-xl rounded-tr-none py-2.5 px-4 text-base shadow-lg">
        {children}
      </div>
    </div>
  )
}
